(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderChangeRequestDeleteController',AppraisalOrderChangeRequestDeleteController);

    AppraisalOrderChangeRequestDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraisalOrderChangeRequest'];

    function AppraisalOrderChangeRequestDeleteController($uibModalInstance, entity, AppraisalOrderChangeRequest) {
        var vm = this;

        vm.appraisalOrderChangeRequest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraisalOrderChangeRequest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
